import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@rtkwlf/pro-solid-svg-icons/faCheck';

import { ListItemIcon, ListItemText } from '@packages/fenrir/components/list';
import { MenuItem } from '@packages/fenrir/components/menu-item';

// TODO: @evagm: Move into Fenrir
// May be grouped within group elements or separated by elements with the separator role or other equivalent native role such as <fieldset> and <hr>.
export const MenuItemCheckbox = ({
  label,
  selected,
  onClick,
}: {
  label: string;
  selected: boolean;
  onClick: () => void;
}) => {
  return (
    <MenuItem onClick={onClick} role="menuitemcheckbox" aria-checked={selected}>
      {selected ? (
        <>
          <ListItemIcon>
            <FontAwesomeIcon icon={faCheck} />
          </ListItemIcon>
          {label}
        </>
      ) : (
        <ListItemText inset>{label}</ListItemText>
      )}
    </MenuItem>
  );
};
